module.exports = __webpack_public_path__ + "static/media/shopping-cart2.2b88d04d.PNG";